// 画像がスクロールする度についてくるアニメーション
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // $('.p-top__mv__img img').css({
    //     transform: 'scale(' + (100 + scroll / 100) / 100 + ')', top: -(scroll / 50) + "%",
    // });
    // $('.p-top__mv__img img').css('transform', 'translateY(' + 100 + (scroll / 100) / 100 + 'px)');
    // $('.p-top__mv__img img').css('transform', 'scale('+ (100 + (scroll / 50)) / 100 + ')');

    // $('.p-top__mv__img img').css('transform', 'translateY('+ (scroll) / 10 + 'px) scale(' + (100 + (scroll / 500)) / 100  + ')');
    $('.p-top__mv__img img').css('transform', 'translateY('+ (-scroll) / 100 + '%) scale(1.2)');
    $('.p-mission__mv__img img').css('transform', 'translateY('+ (-scroll) / 150 + '%) scale(1.2)');
    

});

// 背景画像がスクロールする度についてくるアニメーション
$(window).scroll(function () {
    var scroll = $(window).scrollTop();//スクロール値を定義
    $('.p-top__our-mission').css('background-position', '100% ' + scroll*2 / 100 + '%');
    $('.p-mission__02').css('background-position', '50% ' + scroll*2 / 50 + '%');
    $('.p-mission__04').css('background-position', '50% ' + scroll*2 / 75 + '%');
});